// src/admin/components/StatusDot.tsx — small coloured dot for service-status rows.
import styles from './StatusDot.module.css';

export type DotTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

export default function StatusDot({ tone = 'success', pulse = false }: { tone?: DotTone; pulse?: boolean }) {
  const cls = [styles.dot, styles[tone], pulse && styles.pulse].filter(Boolean).join(' ');
  return <span className={cls} aria-hidden="true" />;
}
